import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Järelmaksu taotlemine

  <span style="color:#85c1dc;">**FI:**</span>
  

  <span style="color:#85c1dc;">**RU:**</span>
  Подача заявления о рассрочке
*/
/* @__NO_SIDE_EFFECTS__ */
const m373 = msg(
  mf`Järelmaksu taotlemine`,
  mf``,
  mf`Подача заявления о рассрочке`,
)

export { m373 as 'w.basket.after_payment_subtitle' }